import type { ReactNode } from "react";

interface EmptyStateProps {
  title: string;
  description?: string;
  action?: ReactNode;
}

const EmptyState = ({ title, description, action }: EmptyStateProps) => (
  <div
    style={{
      border: "1px dashed #cbd5f5",
      borderRadius: "1rem",
      padding: "2.5rem",
      textAlign: "center",
      backgroundColor: "#fff"
    }}
  >
    <h3 style={{ margin: 0, fontSize: "1.5rem", fontWeight: 600 }}>{title}</h3>
    {description ? (
      <p style={{ color: "#64748b", marginTop: "0.75rem" }}>{description}</p>
    ) : null}
    {action ? <div style={{ marginTop: "1.5rem" }}>{action}</div> : null}
  </div>
);

export default EmptyState;
